<template lang="pug">
.card.location-card.mb-3
  .card-body
    .card-title
      .location_info
        img.location-icon(src="@/assets/img/icons/location.svg")
        span
          router-link(
            :to="{ path: '/locations/court', query: { id: court.id } }"
          ) {{ court.name }}
        span.location {{ court.district.name }}
      .right
        a.btn.strength-btn(@click="toEnroll") 立即報名
    .row.training-camps
      .col-12.training-camp
        h6.training-camp-label {{ campName }}
        .training-camp-title.mt-4(
          v-for="course_type in court.course_types",
          :key="course_type.id"
        ) 
          p.age
            img.top-basketball-icon(
              src="@/assets/img/icons/icon_small_basketball.png"
            )
            | {{ course_type.name }}
          span.icon-title(v-for="course_time in course_type.course_times")
            .training-camp-time.date {{ `${course_time.name}` }}
              span.coach(
                v-if="course_time.program_products && course_time.program_products.length > 0",
                @click="coachClick(course_time.program_products[0].coach_name)",
                style="cursor: pointer"
              ) | 教練：{{ course_time.program_products[0].coach_name }}
              .wrapper.d-none.d-md-block
                .course_table.course_head.d-flex.justify-content-center.align-items-center
                  p.text(
                    v-if="course_time.program_products && course_time.program_products.length > 0",
                    v-for="program_product_spec in course_time.program_products[0].program_product_specs"
                  ) {{ program_product_spec.name }}
                .course_table.course_desc.d-flex.justify-content-center.align-items-center
                  p.text(
                    v-if="course_time.program_products && course_time.program_products.length > 0",
                    v-for="program_product_spec in course_time.program_products[0].program_product_specs"
                  ) {{ program_product_spec.val }}
              .course_md.d-md-none
                .course_title_wrapper.d-flex.align-items-center
                .course_content(style="padding: 0")
                  div(
                    v-if="course_time.program_products && course_time.program_products.length > 0",
                    v-for="program_product_spec in course_time.program_products[0].program_product_specs"
                  ) 
                    p {{ program_product_spec.name }}
                    span {{ program_product_spec.val }}
</template>

<script>
export default {
  name: "CourseLocation",
  props: {
    court: Object,
    campName: String,
    coachList: Array,
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    toEnroll() {
      this.$router.push({
        name: "Enroll",
        params: {
          program: this.campName,
        },
      });
    },
    coachClick(coachName) {
      let coachId = -1;
      for (let index in this.coachList) {
        let tempCoach = this.coachList[index];
        if (coachName == tempCoach.name) {
          coachId = tempCoach.id;
          break;
        }
      }

      if (coachId == -1) {
        this.$router.push({ name: "Coaches" });
      } else {
        this.$router.push({ name: "CoachesDetail", query: { id: coachId } });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/locations/course_location.scss";
</style>
